module.exports = {
    PARTNER_TYPES: ["INTERNATIONAL", "EUROPE", "NATIONAL", "REGIONAL", "LOCAL"],
    DEFAULT_TYPE: "LOCAL",
}